import React from "react";
import Constants from "../../../configurations/constants";
import Formsy from "formsy-react";
import { DiscoverFields } from "../../../configurations/discoverConfigs/fields";
import TextInput from "../common/controls/TextInput";
import DatePickerWrapper from "../common/controls/DatePicker";

class DiscoverTransactionSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      canSubmit: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
  }

  disableButton() {
    this.setState({ ...this.state, canSubmit: false });
  }

  enableButton() {
    this.setState({ ...this.state, canSubmit: true });
  }

  handleSubmit(data) {
    let params = {};
    this.props.onSearchHandler(data, params);
  }

  render() {
    const { canSubmit } = this.state;
    return (
      <Formsy
        onValidSubmit={this.handleSubmit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        ref="transactionSearchForm"
        noValidate
      >
        <div className="row">
          <div className="col-md-3">
            <TextInput
              name="pan"
              label={DiscoverFields.cardNumber.label}
              validations={{
                isNumeric: true,
                minLength: DiscoverFields.cardNumber.minLength,
                maxLength: DiscoverFields.cardNumber.maxLength
              }}
              validationErrors={{
                isNumeric: "You must enter digits only",
                minLength: `Card number has a minimum length of ${
                  DiscoverFields.cardNumber.minLength
                }`,
                maxLength: `Card number has a maximum length of ${
                  DiscoverFields.cardNumber.maxLength
                }`
              }}
              required
            />
          </div>
          <div className="col-md-3">
            <DatePickerWrapper
              name={DiscoverFields.transactionDate.name}
              dateFormat={Constants.DATE_FORMAT}
              label={DiscoverFields.transactionDate.label}
              disabledKeyboardNavigation={true}
              peekNextMonth={true}
              showMonthDropdown={true}
              showYearDropdown={true}
              readOnly={true}
              maxDate={0}
              dropdownMode="select"
              required
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-primary btn-block mt-20"
              disabled={!canSubmit}
              type="submit"
            >
              Search
            </button>
          </div>
        </div>
      </Formsy>
    );
  }
}

export default DiscoverTransactionSearch;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/TransactionSearch.js